import LibraryRoutes from "./LibraryRoutes";

export default LibraryRoutes;
